<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
    <img
      v-if="brokerLogo"
      class="mx-auto h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h3 class="my-8 mt-10 text-left text-3xl text-dark-gray">Verification</h3>
    <p class="my-5 text-left text-dark-gray">
      {{ subtitle }}
    </p>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <form-field
        id="login-verification"
        label="Verification Code"
        :value="verification_code"
        placeholder="Enter Verification Code"
        :on-input="onInput"
        name="verification_code"
        maxlength="6"
        :is-valid="!error"
        error-message="Incorrect verification code"
      />
      <button-main
        class="my-3 mb-4"
        :disabled="!isValidCode"
        type="submit"
        :loading-spinner="isLoading"
        value="Continue"
      />
    </form>

    <div class="mt-4 flex flex-col items-center">
      <p class="mb-2 text-body-color">Didn't get a code?</p>
      <router-link
        :to="loginPath"
        class="mx-auto w-max text-yellow-500"
      >
        Try again
      </router-link>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex';

import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'LoginVerification',
  components: {
    Layout,
    ButtonMain,
    FormField,
  },
  props: {
    goBack: Function,
  },
  data() {
    return {
      isEmailRequiredForLogin: this.$route.query?.fromEmail || false,
      isLoading: false,
      error: false,
      verification_code: '',
    };
  },
  async created() {
    await this.$store.dispatch(
      'brokers/getLogoByClientId',
      localStorage.getItem('client_id')
    );
  },
  computed: {
    ...mapState({
      brokerLogo: (state) => state.brokers?.logo?.url || null,
      currentUser: (state) => state.users?.currentUser || {},
    }),
    isValidCode() {
      return this.verification_code && this.verification_code.length === 6;
    },
    subtitle() {
      let source = 'mobile number';
      if (this.isEmailRequiredForLogin) source = 'email address';
      return ` Please enter the code we just sent to the ${source} number you entered.`;
    },
    loginPath() {
      return this.isEmailRequiredForLogin ? '/login-with-email' : '/login';
    },
  },
  mounted() {
    const find = document.querySelector('#login-verification');
    find.focus();
  },
  methods: {
    onInput(e) {
      this.verification_code = e.target.value;
    },
    async handleSubmit() {
      this.isLoading = true;
      const res = await this.$store.dispatch('users/postSignInCode', {
        code: this.verification_code,
      });

      // The endpoint is called to know the value of the property: is_email_required_for_login
      await this.$store.dispatch('users/serverRefreshCurrentUser');

      if ([200, 201].includes(res.status)) {
        // Carrier validation code success
        // Send user to user details step
        this.validation_error = false;
        let redirectAfterSignIn = JSON.parse(
          localStorage.getItem('redirect_url_after_sigin')
        );

        // If they came in through the OAuth process,
        // then then they will be redirected to the /oauth/authorizations
        // endpoint with the correct credentials
        if (redirectAfterSignIn) {
          localStorage.removeItem('redirect_url_after_sigin');
          return this.$router.push(redirectAfterSignIn);
        } else {
          let companyType =
            this.$store.state.users.currentUser.company.company_type;

          switch (companyType) {
            case 'broker':
              return this.$router.push({ name: 'Broker Dashboard' });
            case 'carrier':
              return this.$router.push({ name: 'Carrier Dashboard' });
            case 'dispatcher':
              return this.$router.push({ name: 'Dispatcher Dashboard' });
            default:
              return this.$router.push({ name: 'Home' });
          }
        }
      } else {
        this.validation_error = true;
        toastResponse(this, res, null);
      }
      this.isLoading = false;
    },
  },
};
</script>
